export const PUBLIC_URL = process.env.PUBLIC_URL;

export const APP_NAMES = [
  "ManagIn",
  "BookMySeat",
  "ExcelArt PyPI package",
  "AI Powered Rumour Detection",
  "Portfolio",
];

export const APP_IMAGES = [
  "project_image_1.png",
  "project_image_3.jpg",
  "project_image_2.png",
  "project_image_4.jpg",
  "project_image_5.png",
];

export const APP_DESCRIPTION = [
  "An internal platform for security audit and administration of all devices, remote or within the office network. Features would include security auditing, " +
    "forced patch management, log centralization, data leakage prevention and cryptographic support. I have worked as the lead front-end developer in this project" +
    "Technologies used in this project are React, TypeScript, JavaScript, HTML, SaaS, GIT, React Redux, Axios",
  "This is an internal project developed to permenant seat for employees or book seat when they decide to work from office." +
    "I have worked as the lead front-end developer for this project. The technologies used in this project are React, HTML, SaaS, JavaScript and Leaflet",
  "A python package developed to convert excel files to image. We can specify any row or coloumn and size of image. Created using Python and made the UI using Tkinter. This was developed by me alone",
  "This is an AI Powered rumour Detector. This uses Machine Learning to detect the rumours. It's a website where users can enter the rumour they heard or seen from any source like " +
    "social media, newspaper etc. in the text box and the program will check wether the news is rumour or not usng three steps. one is by using machine learning, secondly it will search in a " +
    "third party website and third it will analyse google results. Second and third part is done using web scraping. Technologies used are Python, ML, AI, HTML, CSS, JavaScript, and Flask",
  "The one you are loooking at right now. I have created this using React, HTML, CSS, and JavaScript",
];

export const VERSION = ["1.0", "1.0", "0.1.2", "1.3", "1.0"];
export const PUBLISHED = [
  "Internal project",
  "Internal project",
  "Published on PyPI official site on Jan 25, 2023",
  "Done as a part of college project",
  "Feb 21, 2024",
];
export const UPDATE = ["NIL", "NIL", "Feb 7, 2023", "NIL", "Feb 21, 2024"];
export const CATEGORY = [
  "React Web App",
  "React Web App",
  "Python package",
  "Website",
  "React Web App",
];
export const INSTALLS = ["NIL", "NIL", "NIL", "NIL", "NIL"];
export const APP_AVAILABILTY = [
  "QBurst internal project*",
  "QBurst internal project",
  "Available to download from PyPI site",
  "College project",
  "Live now",
];
export const APP_DISCLAIMER = [
  "*Due to company policies the web app cannot be made available to public.",
  "*Due to company policies the web app cannot be made available to public.",
  "Download button will take you to the official PyPI site where you can find the details on how to download the package",
  "Since it is not live now download link will not work. You can get the source code and run it",
  "",
];
export const APP_DOWNLOAD_LINK = [
  "",
  "",
  "https://pypi.org/project/excelart/",
  "",
  "",
];
export const APP_SOURCE_CODE_LINK = [
  "",
  "",
  "",
  "https://github.com/ujwalrajeev/Rumour-Detection",
  "https://github.com/ujwalrajeev/Portfolio",
];

export const IMAGE_NAMES = [
  "The Moon closeup",
  "The Bridge",
  "Potrait of a person",
  "Ferris wheel",
  "The Moon",
  "Stars",
];
export const IMAGE_FILE_NAMES = [
  "photography_1.jpg",
  "photography_4.jpg",
  "photography_6.jpg",
  "photography_5.jpg",
  "photography_3.jpg",
  "photography_2.jpg",
];
export const IMAGE_DESCRIPTION = [
  "A closeup photo of moon taken during night using Canon PowerShot SX540HS.",
  "Color makes everything distinct, The bird, sky, bridge, and lamp everything blends together. This is a photo from Doha Qatar. Captured using Canon Powershot SX540HS.",
  "Captured this on Canon Powershot SX540HS when vidited Qatar.",
  "Captured this colorful image during a festival nearby on Google Pixel 7.",
  "Another closeup photo of moon captured on Canon PowerShot SX540HS. f/8.0 . 1/320 . 215.00mm . ISO 200",
  "My first star photography. This was captured on Google Pixel 7. I have used astrophotography mode and captured the sky for 14 minutes to capture this.",
];
export const IMAGE_CAPTURED_DATE = [
  "September 21, 2023",
  "May 24, 2023",
  "May 19, 2023",
  "August 28, 2023",
  "September 21, 2023",
  "September 21, 2023",
];
export const IMAGE_CATEGORY = [
  "Astrophotography",
  "Architecture Photography",
  "Potrait photography",
  "Night photography",
  "Astrophotography",
  "Astrophotography",
];

export const ART_NAMES = [
  "Cuckoo",
  "For Paul",
  "Hala Al Turk",
  "Jessica Alba",
  "O Yeong-su",
  "Olivia Rodrigo",
];
export const ART_DESCRIPTION = [
  "Potrait of my best friend. The original photo was also taken by me.",
  "Drawing of my favourite actor Paul Walker. I am a great fan of Fast and Furious.",
  "One of my favourite Arabic singer. Started listening to her song when I visited Qatar.",
  "One of my favourite hollywood actress.",
  "The 001 player and the master mind of Squid Game. My first Korean series.",
  "One of my favourite singer",
];
export const ART_CATEGORY = [
  "Water color and pencil color",
  "Pencil color",
  "Water color and pencil color",
  "Pencil shading",
  "Pencil shading",
  "Pencil shading and pencil color",
];
export const ART_FILE_NAMES = [
  "art_1.jpg",
  "art_5.jpg",
  "art_4.jpg",
  "art_3.jpg",
  "art_6.jpg",
  "art_7.jpg",
];

export const SCIENCE_DISCOVERY_NAMES = ["MAGIC PAPER"];
export const SCIENCE_DISCOVERY_FILE_NAMES = ["science_1.jpg"];
export const SCIENCE_DISCOVERY_DESCRIPTION = [
  "Found out this effect while studing for the 10th standard exams. Take an opaque paper (When we place the paper another paper or textbook page " +
    "the letters beneath it should not be seen from above but if pass light through back side of printed paper and it should passes through the top paper). Now place the " +
    "paper on top of a textbook page with writings. We will not be able to see the letters below. But as we move the top paper fastly to and forth, the letters below will " +
    "be visible on top paper. As speed of movement increases the more clearer will be the text. Reasearch is ongoing, some of my theory is as the paper moves fastly the atoms " +
    "inside the top paper will move fastly so small empty spaces appear here and there between atoms. Through that light can pass and we can see the text below.",
];
export const SCIENCE_DISCOVERY_DATE = ["November, 2015"];
